// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "main." + {"364":"e93353a423a05948e041","792":"580b8730f7fdd3784e66"}[chunkId] + ".js";
};